import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Routes } from "../../utils/constants";
import ResendMail from "../../components/Email/ResendMail";
import { authHelper } from "../../utils/helpers";
import { getInflowCategory } from "../../utils/helpers/tracking";

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const RegisterEmailSent: React.FC = () => {
  const [isResend, setIsResend] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  // Get from state if available, otherwise fallback to query params
  const emailFromState = location.state?.email;
  const isRegisterSimple = location.state?.isRegisterSimple ?? false;
  const queryParams = new URLSearchParams(location.search);
  const emailFromQuery = queryParams.get("email");
  const userId = location.state?.user_id || null;

  // Prioritize getting from state, otherwise get from query
  const email = emailFromState || emailFromQuery || "";
  const handleTrackingRegisterEvent = () => {
    const returnToUrl = localStorage.getItem("trackingInflowRoute");
    if (returnToUrl) {
      const inflowCategory = getInflowCategory(returnToUrl);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view",
        inflow_url: returnToUrl,
        inflow_category: inflowCategory,
        auth0_user_id: userId,
      });
      localStorage.removeItem("trackingInflowRoute");
    }
  };

  useEffect(() => {
    if (authHelper.accessToken()) {
      navigate(Routes.VERIFY_EMAIL_FINISH);
    }
    // If emailFormQuery is not empty, it means the user is trying to resend the email
    if (emailFromQuery) {
      setIsResend(true);
    }
  }, []);
  useEffect(() => {
    handleTrackingRegisterEvent();
  }, []);

  return (
    <div className="register-page email-sent">
      <section>
        <div className="rp-head">
          <div className="step-info">
            <div className="page-title">
              <span>{isResend ? "確認メール送信" : "確認メール送信完了"}</span>
            </div>
            {isResend ? (
              <ResendMail email={email} setIsResend={setIsResend} />
            ) : (
              <p className="description">{`メールアドレス ”${email}” へ、確認用メールを送信いたしました。\n現在は仮登録状態となっており、メール本文内に記載されているURLにアクセスすることで、会員登録は完了いたします。\n 外部アカウントを利用してログインする場合、会員登録完了後にマイページ「外部アカウント連携」より設定をお願いします。`}</p>
            )}
          </div>
        </div>
      </section>
      {isResend ? (
        <></>
      ) : (
        <section className="register-form">
          <div>
            <div className="instruct-note">
              <div className="subtitle">
                <span>確認メールが届かない方へ</span>
              </div>
              <div className="content">
                <ul>
                  <li>
                    こちらの
                    <span
                      className="hight-light"
                      onClick={() => setIsResend(true)}
                    >
                      「本人確認メールを再送する」
                    </span>
                    をクリックいただきメールを再送してください。
                  </li>
                  <li>
                    メールアドレスに誤りがある場合は再度
                    <span
                      className="hight-light"
                      onClick={() => {
                        authHelper.logOut();
                        navigate(
                          isRegisterSimple
                            ? Routes.REGISTERSIMPLE
                            : Routes.REGISTER,
                        );
                      }}
                    >
                      「新規会員登録」
                    </span>
                    よりお手続きください。
                  </li>
                  <li>
                    迷惑メールフォルダへ振り分けられている場合がございますので、ご確認ください。
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <div className="buttons">
              <Link to={"/"} className="btn-back">
                <span>画面を閉じる</span>
              </Link>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default RegisterEmailSent;
